<template>
  <v-card class="rounded-lg white">
    <v-card-title class="secondary--text">{{ title }}</v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12" md="12">
          <v-row>
            <v-col cols="12" md="2">
              <v-select
                  :menu-props="{ bottom: true, offsetY: true }"
                  class="rounded-lg"
                  label="نوع تراز"
                  v-model="filters.cols_count"
                  :items="balanceTypes"
                  :return-object="false"
              />
              <v-select
                  :disabled="contraryToNature"
                  :menu-props="{ bottom: true, offsetY: true }"
                  offset-y
                  class="mt-3 rounded-lg"
                  :items="accountStatuses"
                  v-model="filters.balance_status"
                  label="وضعیت حساب"
              />

              <v-switch
                  :disabled="contraryToNature"
                  v-if="!isPersonReport"
                  inset
                  color="success"
                  class="mt-3"
                  label="نمایش حساب های خلاف ماهیت"
                  v-model="filters.show_differences"
              />
            </v-col>

            <template v-if="showAccountFilters">
              <v-col cols="12" md="2">
                <div v-show="!isPersonReport">
                  <v-select
                      :menu-props="{ bottom: true, offsetY: true }"
                      class="rounded-lg"
                      label="سطح حساب"
                      v-model="filters.level"
                      item-text="text"
                      item-value="value"
                      :items="accountLevels"
                      :return-object="false"
                      @input="isReview?clearReviewFilter(false):null"
                  />

                  <v-select
                      :menu-props="{ bottom: true, offsetY: true }"
                      class="mt-3 rounded-lg"
                      label="حساب های خاص"
                      v-model="filters.account_type"
                      :items="specialAccounts"
                      item-text="text"
                      item-value="value"
                      :return-object="false"
                  />
                </div>
                <v-switch
                    v-if="isPersonReport"
                    inset
                    color="success"
                    class="mt-3"
                    label="نمایش حساب های خلاف ماهیت"
                    v-model="filters.show_differences"
                />

                <v-switch v-show="!isXs"
                          inset
                          color="success"
                          label="نمایش حساب های تفضیلی شناور"
                          v-model="filters.show_float_accounts"
                          class="mt-3 text-right"
                />
              </v-col>

              <v-col cols="12" md="2" v-show="!isXs">
                <v-text-field
                    class="rounded-lg"
                    label="از کد حساب"
                    type="number"
                    v-model="filters.account__code__gte"
                />
                <v-text-field
                    class="rounded-lg mt-3"
                    label="تا کد حساب"
                    type="number"
                    v-model="filters.account__code__lte"
                />
              </v-col>
            </template>

            <v-col cols="12" md="2" v-show="!isXs">
              <v-select
                  :menu-props="{ bottom: true, offsetY: true }"
                  class="rounded-lg"
                  label="از ماه"
                  v-model="filters.from_date"
                  item-text="title"
                  item-value="start"
                  :items="month_items"
                  :return-object="false"
                  clearable
              />

              <v-select
                  :menu-props="{ bottom: true, offsetY: true }"
                  class="mt-3 rounded-lg"
                  label="تا ماه"
                  v-model="filters.to_date"
                  :items="month_items"
                  item-text="title"
                  item-value="end"
                  :return-object="false"
                  clearable
              />

            </v-col>
            <v-col cols="12" md="2" v-show="!isXs">
              <date label="از تاریخ" v-model="filters.from_date" :defualt="false"/>
              <div class="mt-3">
                <date label="تا تاریخ" v-model="filters.to_date" :defualt="false"/>
              </div>
            </v-col>
            <v-col cols="12" md="2" v-show="!isXs && !isPersonReport">
              <v-text-field class="rounded-lg" label="از شماره سند" type="number" v-model="filters.from_code"/>
              <v-text-field class="rounded-lg mt-3" label="تا شماره سند" type="number" v-model="filters.to_code"/>
            </v-col>
            <v-col cols="12" md="2"></v-col>
          </v-row>
          <v-tooltip left color="#019EF6">
            <template v-slot:activator="{ on, attrs }">
              <v-hover v-slot="{ hover }">
                <v-btn
                    v-bind="attrs"
                    :style="{ color: hover ? '#019EF6' : '#697480' }"
                    v-on="on"
                    depressed
                    class="refresh"
                    icon
                    @click="isReview?clearReviewFilter(true):refreshPage()"
                >
                  <v-img v-if="isReview" src="/img/icons/goBack.svg" max-width="25"></v-img>
                  <v-img v-else src="/img/icons/reload.svg" max-width="25"></v-img>
                </v-btn>
              </v-hover>
            </template>
            <span v-if="isReview">
              بازگشت به گروه حساب ها
            </span>
            <span v-else>
              دریافت دوباره اطلاعات
            </span>
          </v-tooltip>
          <v-col cols="12"></v-col>
          <template v-if="showAccountFilters"></template>
        </v-col>

        <v-col cols="12" style="margin-top: -30px">
          <m-datatable
              ref="datatable"
              :headers="headers"
              :show-row-number="!isXs"
              :items="items"
              :hidden-cols="hiddenCols"
              :export-url="url"
              :filters.sync="filters"
              :expanded.sync="items"
              :show-select="false"
              :additionalAppliedFilters="additionalAppliedFilters"
              @update:options="setShowSum"
              @dblclick:row="(e, row) => openLedger(getAccountLedgerQuery(row.item))"
              @click:row="(e, row) => setFilters(row)"
          >
            <template #item.data-table-expand></template>

            <template
                v-if="filters.show_float_accounts || filters.show_cost_centers"
                v-slot:expanded-item="{ headers, item }"
            >
              <template v-if="hasSubAccount(item)">
                <td colspan="2"></td>
                <td class>
                  <div class="py-1" v-for="(subAccount, i) in getSubAccounts(item)">{{ subAccount.name }}</div>
                </td>
                <td v-if="filters.cols_count > 4" :colspan="(filters.cols_count == 8)?4:2"></td>
                <td class="text-center">
                  <div class="py-1" v-for="(subAccount, i) in getSubAccounts(item)">
                    {{ subAccount.bed_sum | toMoney }}
                  </div>
                </td>
                <td class="text-center">
                  <div class="py-1" v-for="(subAccount, i) in getSubAccounts(item)">
                    {{ subAccount.bes_sum | toMoney }}
                  </div>
                </td>
                <template v-if="filters.cols_count != 2">
                  <td class="text-center">
                    <div class="py-1" v-for="(subAccount, i) in getSubAccounts(item)">
                      {{ subAccount.bed_remain | toMoney }}
                    </div>
                  </td>
                  <td class="text-center">
                    <div class="py-1" v-for="(subAccount, i) in getSubAccounts(item)">
                      {{ subAccount.bes_remain | toMoney }}
                    </div>
                  </td>
                </template>
                <td>
                  <div v-if="getSubAccountLedgerQuery" v-for="(subAccount, i) in getSubAccounts(item)"
                       :class="filters.cols_count == 2?'mr-15':null">
                    <open-ledger-btn :query="getSubAccountLedgerQuery(item, subAccount)"/>
                  </div>
                </td>
              </template>
            </template>

            <template v-slot:body.append="{ headers }" v-if="showSum">
              <tr class="text-center white--text secondary" style="position: sticky; bottom: 0">
                <td :colspan="0 + cols.cols.length + !isXs - 1"></td>
                <td class="primary--text font-weight-bold">جمع کل</td>
                <template v-if="filters.cols_count > 6">
                  <td>{{ sum["openingBed"] | toMoney }}</td>
                  <td>{{ sum["openingBes"] | toMoney }}</td>
                </template>
                <template v-if="filters.cols_count > 4">
                  <td>{{ sum["previousBed"] | toMoney }}</td>
                  <td>{{ sum["previousBes"] | toMoney }}</td>
                </template>
                <template v-if="filters.cols_count > 2">
                  <td>{{ sum["bed"] | toMoney }}</td>
                  <td>{{ sum["bes"] | toMoney }}</td>
                </template>
                <td>{{ sum["bedRemain"] | toMoney }}</td>
                <td>{{ sum["besRemain"] | toMoney }}</td>
                <td></td>
              </tr>
            </template>

            <template #item.ledger="{ item }" v-if="getAccountLedgerQuery">
              <open-ledger-btn :query="getAccountLedgerQuery(item)"/>
            </template>
          </m-datatable>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import datatableBaseCols from "./_datatableBaseCols";
import mobileDatatableBaseCols from "./_mobileDatatableBaseCols"
import AccountApiMixin from "@/mixin/accountMixin";
import _ from "lodash";
import OpenLedgerBtn from "@/components/btns/OpenLedgerBtn.vue";
import {AcroFormTextField} from "jspdf";

export default {
  name: "Balance",
  mixins: [AccountApiMixin],
  components: {OpenLedgerBtn},
  props: {
    title: {
      required: true,
    },
    cols: {
      required: true,
    },
    url: {
      required: true,
    },
    showAccountFilters: {
      default: true,
    },
    getAccountLedgerQuery: {
      default: null,
    },
    getSubAccountLedgerQuery: {
      default: null,
    },
    defaultFilters: {
      default: null,
    },
    isPersonReport: {
      default: false,
    },
    contraryToNature: {
      default: false,
    },
    isReview: {
      default: false,
    },
  },
  data() {
    return {
      month_items: [],
      sanadFilters: {},
      accountFilters: {},
      select_account_name: null,

      filters: {
        level: null,
        account_type: null,
        cols_count: null,
        balance_status: null,
      },

      showSum: false,

      allAccounts: [],
      items: [],
      debouncedGetData: null,
      debouncedFilterAccounts: null,

      balanceTypes: [
        {
          text: "2 ستونی",
          value: 2,
        },
        {
          text: "4 ستونی",
          value: 4,
        },
        {
          text: "6 ستونی",
          value: 6,
        },
        {
          text: "8 ستونی",
          value: 8,
        },
      ],
      accountLevels: [
        {value: null, text: "همه"},
        {value: 0, text: "گروه"},
        {value: 1, text: "کل"},
        {value: 2, text: "معین"},
        {value: 3, text: "تفضیلی"},
      ],
      specialAccounts: [
        {value: null, text: "همه"},
        {value: "bank", text: "بانک"},
        {value: "pos", text: "کارتخوان"},
        {value: "gateway", text: "درگاه بانکی"},
        {value: "deposit", text: "صندوق"},
        {value: "buyer", text: "خریدار"},
        {value: "seller", text: "فروشنده"},
        {value: "partner_receive", text: "جاری شرکا دریافتنی"},
        {value: "partner_payment", text: "جاری شرکا پرداختنی"},
        {value: "imprest", text: "تنخواه گردان"},
      ],
      accountStatuses: [
        {value: null, text: "همه"},
        {value: "with_remain", text: "حساب های دارای مانده"},
        {value: "bed_remain", text: "مانده بدهکار"},
        {value: "bes_remain", text: "مانده بستانکار"},
        {value: "without_remain", text: "بدون مانده"},
        {value: "with_transaction", text: "حساب های دارای گردش"},
        {value: "without_transaction", text: "حساب های بدون گردش"},
      ],
    };
  },
  computed: {
    sum() {
      let bed = 0,
          bes = 0,
          bedRemain = 0,
          besRemain = 0,
          openingBed = 0,
          openingBes = 0,
          previousBed = 0,
          previousBes = 0;
      const targetLevel = this.filters.level != undefined ? this.filters.level : 3;
      for (const account of this.items) {
        if (![undefined, null].includes(account.level)) {
          if (account.level == targetLevel) {
            bed += +account.bed_sum;
            bes += +account.bes_sum;
            bedRemain += +account.bed_remain;
            besRemain += +account.bes_remain;
            previousBed += +account.previous_bed_sum;
            previousBes += +account.previous_bes_sum;
            openingBed += +account.opening_bed_sum;
            openingBes += +account.opening_bes_sum;
          }
        } else {
          bed += +account.bed_sum;
          bes += +account.bes_sum;
          bedRemain += +account.bed_remain;
          besRemain += +account.bes_remain;
          previousBed += +account.previous_bed_sum;
          previousBes += +account.previous_bes_sum;
          openingBed += +account.opening_bed_sum;
          openingBes += +account.opening_bes_sum;
        }
      }

      return {
        bed,
        bes,
        bedRemain,
        besRemain,
        previousBed,
        previousBes,
        openingBed,
        openingBes,
      };
    },
    hiddenCols() {
      if (this.filters.cols_count == 6) return ["opening_bed_sum", "opening_bes_sum"];
      if (this.filters.cols_count == 4)
        return ["opening_bed_sum", "opening_bes_sum", "previous_bed_sum", "previous_bes_sum"];
      if (this.filters.cols_count == 2)
        return ["bed_sum", "bes_sum", "opening_bed_sum", "opening_bes_sum", "previous_bed_sum", "previous_bes_sum"];
      return [];
    },
    headers() {
      if (this.isXs) {
        var cols = [...this.cols.cols, ...mobileDatatableBaseCols.cols];
      } else {
        var cols = [...this.cols.cols, ...datatableBaseCols.cols];
      }
      cols = cols.filter((o) => !this.hiddenCols.includes(o.value));
      return cols;
    },
    additionalAppliedFilters() {
      let appliedFilters = [];

      const selectFilters = [
        {
          text: "سطح حساب",
          value: this.filters.level,
          items: this.accountLevels,
        },
        {
          text: "وضعیت حساب",
          value: this.filters.balance_status,
          items: this.accountStatuses,
        },
        {
          text: "حساب های خاص",
          value: this.filters.account_type,
          items: this.specialAccounts,
        },
      ];

      for (const filter of selectFilters) {
        if (filter.value) {
          appliedFilters.push({
            text: filter.text,
            value: filter.items.find((o) => o.value == filter.value).text,
          });
        }
      }

      const switchFilters = [
        {
          text: "نمایش حساب های خلاف ماهیت",
          value: this.filters.show_differences,
        },
        {
          text: "نمایش حساب های تفضیلی شناور",
          value: this.filters.show_float_accounts,
        },
      ];

      for (const filter of switchFilters) {
        if (filter.value) {
          appliedFilters.push({
            text: filter.text,
            value: "بله",
          });
        }
      }

      const textFilters = [
        {
          text: "از کد حساب",
          value: this.filters.account__code__gte,
        },
        {
          text: "تا کد حساب",
          value: this.filters.account__code__lte,
        },
        {
          text: "از تاریخ",
          value: this.toJDate(this.filters.from_date),
        },
        {
          text: "تا تاریخ",
          value: this.toJDate(this.filters.to_date),
        },
        {
          text: "از شماره سند",
          value: this.filters.from_code,
        },
        {
          text: "تا شماره سند",
          value: this.filters.to_code,
        },
      ];

      if (this.filters.account_code_starts_with && this.isReview) {
        textFilters.push(
            {
              text: "حساب",
              value: this.select_account_name,
            },

        )
      }

      for (const filter of textFilters) {
        if (filter.value) {
          appliedFilters.push({
            text: filter.text,
            value: filter.value,
          });
        }
      }

      return appliedFilters;
    },
  },
  created() {
    this.debouncedGetData = _.debounce(this.getData, 1000);
    this.clearFilters();
  },
  mounted() {
    this.month_items = this.getFinancialYearMonths()
    if (this.defaultFilters) {
      this.updateFilters(this.defaultFilters);
    }
  },
  watch: {
    url() {
      this.getData();
    },
    filters: {
      handler() {
        if (this.debouncedGetData) this.debouncedGetData();
        else this.getData();
      },
      deep: true,
    },
    defaultFilters: {
      handler() {
        this.updateFilters(this.defaultFilters);
      },
      deep: true,
    },
  },
  methods: {
    setFilters(row){
      if (this.isReview){
        if (this.filters.level != 3){
          this.filters.level = row.item.level + 1
          this.filters.account_code_starts_with = row.item.code
          this.select_account_name = row.item.name
        }
      }

    },
    clearReviewFilter(clearLevel){
      this.filters.account_code_starts_with = null
      this.select_account_name = null
      if (clearLevel) {
        this.filters.level = 0
      }

    },
    openLedger(query) {
      let routeData = this.$router.resolve({
        name: "LedgerReport",
        query: query,
      });
      if (this.isXs) {
        window.open(routeData.href, "_blank");
      }

    },


    updateFilters(newFilters) {
      Object.keys(newFilters).forEach((key) => {
        this.$set(this.filters, key, newFilters[key]);
      });
      this.debouncedGetData();
      if (this.isXs) {
        this.filters.cols_count = 2
      }
    },
    setShowSum(options) {
      let {page, itemsPerPage} = options;
      const lastPage = Math.ceil(this.items.length / itemsPerPage);
      if (itemsPerPage == -1 || page == lastPage || lastPage == 0) {
        this.showSum = true;
      } else {
        this.showSum = false;
      }
    },
    hasSubAccount(item) {
      return item.floatAccounts_data && item.floatAccounts_data.length;
    },
    getSubAccounts(item) {
      let subAccounts = [];

      if (this.filters.show_float_accounts) {
        let floatAccounts = item.floatAccounts_data;
        floatAccounts.forEach((o) => (o.level = "floatAccounts"));
        subAccounts = [...subAccounts, ...floatAccounts];
      }

      return subAccounts;
    },
    getData() {
      const filters = this.getFilters();
      this.request({
        url: this.endpoint(this.url),
        method: "get",
        params: filters,
        success: (data) => {
          this.items = data;
        },
      });
    },
    clearFilters() {
      this.accountFilters = {
        level: null,
        status: null,
        special: null,
        showFloatAccounts: false,
        showDifferences: false,
      };
      this.sanadFilters = {};
      this.filters = {
        cols_count: 2,
      };
    },
    getFilters() {
      let filters = this.copy(this.filters);
      const codeLength = 9;

      let code = filters.account__code__gte;
      if (code) {
        for (let i = 0; i < codeLength - code.length; i++) code += "0";
        filters.account__code__gte = code;
      }

      code = filters.account__code__lte;
      if (code) {
        for (let i = 0; i < codeLength - code.length; i++) code += "9";
        filters.account__code__lte = code;
      }

      return filters;
    },
    refreshPage() {
      window.location.reload();
    },
  },
};
</script>

<style lang="scss">
.v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: none !important;
}

.theme--light.v-label,
.v-data-table-header th {
  color: #212121 !important;
}

.refresh {
  margin-top: 10px;
}
</style>
